import { defineMessages } from "react-intl";

export default defineMessages({
  dropAreaInfo1: {
    id: "common.dropAreaInfo1",
    defaultMessage:
      "Voit raahata tiedostot tähän tai klikata aluetta lisätäksesi liitteitä."
  },
  dropAreaInfo2: {
    id: "common.dropAreaInfo2",
    defaultMessage: "Liitteet näkyvät alla"
  },
  dropAreaInfo3: {
    id: "common.dropAreaInfo3",
    defaultMessage: "Pudota tiedostot tähän ..."
  },
  nimeaLiiteTarvittaessa: {
    id: "attachments.nimeaLiiteTarvittaessa",
    defaultMessage:
      "Nimeä liite tarvittaessa uudelleen sisältöä paremmin kuvaavaksi."
  }
});
